<!--
 * @Description: 详情页
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2020-07-02 07:28:56
 * @LastEditors: 山淑兰
-->
<template>
  <div class="details">
    <div class="loading" v-if="loading">
      <van-loading
        type="spinner"
        color="#3b82f6"
        vertical
        size="30px"
        text-size="16px"
        >加载中...</van-loading
      >
    </div>
    <div class="details-con" v-else>
      <div class="details-return"  @click="goBack()">
        <img src="../../../assets/back.png">  
      </div>
      <div class="details-con-main">
        <template v-if="$i18n.locale === 'zh-CN'">
        <!-- 头像部分 -->
          <div class="details-cons">
            <div class="details-head">
               
                <div class="guest-headimg" @click="viewPhoto()">
                  <img :src="this.dataList.photo || this.defaultHeadImg" alt />
                </div>
                <div class="guest-top">
                  <div class="guest-intro">
                    <div class="guest-name">
                      <span v-html="nToBr(this.dataList.cnname)"></span>
                    </div>
                    <div class="host" v-html="nToBr(this.dataList.cncompany)"></div>
                  </div>
                </div>
            </div>
            <div id="guestIntroduction-con" v-if="this.dataList.cnintroduction!=null">
                <h4>{{ $t('meeting.details.guestsIntroductionTitle') }}</h4>
                <p
                  v-html="this.dataList.cnintroduction"></p>
            </div>
          </div>
        </template>
        <template v-else>
        <!-- 头像部分 -->
          <div class="details-cons">
            <div class="details-head">
               
                <div class="guest-headimg" @click="viewPhoto()">
                  <img :src="this.dataList.photo || this.defaultHeadImg" alt />
                </div>
                <div class="guest-top">
                  <div class="guest-intro">
                    <div class="guest-name">
                      <span v-html="this.dataList.enname?nToBr(this.dataList.enname):nToBr(this.dataList.enname)"></span>
                    </div>
                    <div class="host">
						{{ (this.dataList.encmpany==null||this.dataList.encmpany=='')?this.dataList.cncompany:this.dataList.encmpany }}
					</div>
                  </div>
                </div>
            </div>
            <div id="guestIntroduction-con" v-if="this.dataList.enintroduction!=null">
                <h4>{{ $t('meeting.details.guestsIntroductionTitle') }}</h4>
                <p
                  v-html="this.dataList.enintroduction"></p>
            </div>
          </div>
        </template>
        <template v-if="$i18n.locale == 'zh-CN'">
          <div class="details-main">
            <div
              v-show="show == 'tasks'"
              v-for="(item, index) in list"
              :key="index"
            >
              <div class="details-main-head">
                <van-cell
                  :title="item[0].createdTime"
                  icon="send-gift-o"
                  class="details-main-head-date"
                />
                <div class="details-list-num">{{ item[0].total }}</div>
              </div>
              <van-cell
                class="details-main-con"
                v-for="(i, id) in item"
                :key="id"
              >
                <div class="meeting-list" v-if="i.url!=null">
                  <div class="meeting-left">
					<van-cell icon="underway-o" class="major-title">
						{{ i.startTime + '-' + i.endTime }} {{ i.topic }}
					</van-cell>
                    <a v-if="i.roomTitle || i.roomName">
                      <van-cell
                        icon="orders-o"
                        class="major-title"
                        :class="{ _link: i.url }"
                        >{{ i.roomTitle }}</van-cell
                      >
                      <van-cell
                        icon="location-o"
                        class="major-title"
                        :class="{ _link: i.url }"
                        >{{i.roomName }}</van-cell
                      ></a
                    >
					
                    <van-cell class="major-title" icon="user-o" v-if="i.roleName">{{
                      i.roleName
                    }}</van-cell>
                    <!-- <van-cell
                      icon="underway-o"
                      class="major-title"
                      v-if="i.startTime"
                      >{{ i.startTime + '-' + i.endTime }}</van-cell
                    > -->
                  </div>
                  <div class="meeting-icon">
                    <a :href="i.url" target="_top">
                      <img src="../../../assets/creame2.png">  
                      <p>点击观看直播</p>
                    </a>
                  </div>
                </div>
                 <div class="meeting-list"  v-if="i.url==null"  @click="goMeeting($event,i.dateid,i.roomid)">
                  <div class="meeting-left"> 
                    <a v-if="i.roomTitle || i.roomName">
					 <van-cell icon="underway-o" class="major-title">
					   {{ i.startTime + '-' + i.endTime }} <span v-html="nToBr(i.topic)"></span>
					 </van-cell>
                      <van-cell
                        icon="orders-o"
                        class="major-title"
                        :class="{ _link: i.url }"
                        >{{ i.roomTitle }}</van-cell
                      >
                      <van-cell
                        icon="location-o"
                        class="major-title"
                        :class="{ _link: i.url }"
                        >{{i.roomName }}</van-cell
                      ></a
                    >
					
                    <van-cell class="major-title" icon="user-o" v-if="i.roleName">{{
                      i.roleName
                    }}</van-cell>
                    <!-- <van-cell
                      icon="underway-o"
                      class="major-title"
                      v-if="i.startTime"
                      >{{ i.startTime + '-' + i.endTime }}</van-cell
                    > -->
                  </div>
                  <div class="meeting-icon" v-if="i.url==null">
                    <img class="arrow" src="../../../assets/arrow-r.png">
                  </div>
                </div>
              </van-cell>
            </div>
            <!-- <div
              id="guestIntroduction-con"
            >
              <h4>{{ $t('meeting.details.guestsIntroductionTitle') }}</h4>
              <p
                v-html="
                  this.dataList.cnintroduction ||
                    $t('meeting.details.guestsIntroduction')
                "
              ></p>
            </div> -->
          </div>
        </template>
        <template v-else>
          <div class="details-main">
            <div
              v-show="show == 'tasks'"
              v-for="(item, index) in list"
              :key="index"
            >
              <div class="details-main-head">
                <van-cell
                  :title="item[0].createdTime"
                  icon="send-gift-o"
                  class="details-main-head-date"
                />
                <div class="details-list-num">{{ item[0].total }}</div>
              </div>
              <van-cell
                class="details-main-con"
                v-for="(i, id) in item"
                :key="id"
              >
                <div class="meeting-list" v-if="i.url!=null">
                  <div class="meeting-left">
                    <a v-if="i.roomEnTitle || i.roomEnName">
                      <van-cell
                        icon="location-o"
                        class="major-title"
                        :class="{ _link: i.url }"
                        >{{ i.roomEnTitle }}</van-cell
                      >
                      <van-cell
                        icon="orders-o"
                        class="major-title"
                        :class="{ _link: i.url }"
                        >{{i.roomEnName }}</van-cell
                      ></a
                    >
					<van-cell icon="underway-o" class="major-title">
					  {{ i.startTime + '-' + i.endTime }} <span v-html="nToBr(i.entopic)"></span>
					</van-cell>
                    <van-cell class="major-title" icon="user-o" v-if="i.roleName">{{
                      i.roleName
                    }}</van-cell>
                    <!-- <van-cell
                      icon="underway-o"
                      class="major-title"
                      v-if="i.startTime"
                      >{{ i.startTime + '-' + i.endTime }}</van-cell
                    > -->
                  </div>
                  <div class="meeting-icon">
                    <a :href="i.url" target="_top">
                      <img src="../../../assets/creame2.png">  
                      <p>点击观看直播</p>
                    </a>
                  </div>
                </div>
                 <div class="meeting-list"  v-if="i.url==null"  @click="goMeeting($event,i.dateid,i.roomid)">
                  <div class="meeting-left">
                    <a v-if="i.roomEnTitle || i.roomEnName">
                      <van-cell
                        icon="location-o"
                        class="major-title"
                        :class="{ _link: i.url }"
                        >{{ i.roomEnTitle }}</van-cell
                      >
                      <van-cell
                        icon="orders-o"
                        class="major-title"
                        :class="{ _link: i.url }"
                        >{{i.roomEnName }}</van-cell
                      ></a
                    >
					<van-cell icon="underway-o" class="major-title">
					  {{ i.startTime + '-' + i.endTime }} {{ i.entopic }}
					</van-cell>
                    <van-cell class="major-title" icon="user-o" v-if="i.roleName">{{
                      i.roleName
                    }}</van-cell>
                    <!-- <van-cell
                      icon="underway-o"
                      class="major-title"
                      v-if="i.startTime"
                      >{{ i.startTime + '-' + i.endTime }}</van-cell
                    > -->
                  </div>
                  <div class="meeting-icon" v-if="i.url==null">
                    <img class="arrow" src="../../../assets/arrow-r.png">
                  </div>
                </div>
              </van-cell>
            </div>
            <!-- <div
              id="guestIntroduction-con"
            >
              <h4>{{ $t('meeting.details.guestsIntroductionTitle') }}</h4>
              <p
                v-html="
                  this.dataList.cnintroduction ||
                    $t('meeting.details.guestsIntroduction')
                "
              ></p>
            </div> -->
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from 'vant'
import defaultHeadImg from '../../../assets/defaultHeadImg.png'

export default {
  neme: 'details',

  data() {
    return {
      loading: false,

      show: 'tasks',
      defaultHeadImg,
      list: {},
      dataList: [],
      exid: '',
	  language: '',
    }
  },
  watch: {
    $route(to, from) {
      if (to.query.exid != from.query.exid && to.query.exid) {
        this.exid = to.query.exid
        this.init()
      }
    },
  },
  created() {
    if (this.$route.query) {
      this.exid = this.$route.query.exid
	  this.language = this.$route.query.language
      this.init()
    }
  },
  methods: {
    goBack(){
      this.$router.go(-1);
    },
    showCon(index) {
      if (index == 'tasks') {
        this.show = 'tasks'
      } else {
        this.show = 'guestIntroduction'
      }
    },

    formatTime(val) {
      let et = val.split('(')
      let end = et[1].split(')')[0]
      let endtime = Number(end)
      let date = new Date(endtime)
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let m = date.getMinutes()
      m = m < 10 ? '0' + m : m
      return h + ':' + m
    },
    formatDate(val) {
      let et = val.split('(')
      let end = et[1].split(')')[0]
      let date = new Date(Number(end))
      let month = date.getMonth() + 1
      let day = date.getDate()
      return month + '-' + day
    },
    async init() {
      try {
        this.loading = true
        const { m, exid } = this.$route.query

        const _params = { m, exid }
        const PopupData = await this.$http.initScheduleInfo({ m })
        this.$emit('searchDatas', PopupData.childens)

        const res = await this.$http.initGuestInfo(_params)

        // 头像卡片部分
        this.dataList = res.expert
        if (this.dataList.cnintroduction) {
          this.dataList.cnintroduction = this.dataList.cnintroduction.replace(
            /\n/g,
            '<br>'
          )
        }
        if (this.dataList.enintroduction) {
          this.dataList.enintroduction = this.dataList.enintroduction.replace(
            /\n/g,
            '<br>'
          )
        }
        console.log(this.dataList)

        let _list = []
        res.DateListEntity.map((item) => {
          let _k = []
          for (let i in item.programListEntity) {
            let _D = item.programListEntity[i]
            let { programList } = _D.programs
            for (let j in programList) {
              let _S = programList[j]
              console.log(_S)
              programList[j] = {
                url: _S.programRoom.url,
                //中文
                createdTime: this.formatDate(_S.programDate.prodate),
                startTime: _S.starttime,
                endTime: _S.endtime,
                total: item.ProgramCount, //总数量
                pohto: res.expert.photo, //头像路径
                topic: _S.topic,
                roomName: _S.programRoom.roomname,
                roomTitle: _S.programRoom.roomtitle,
                roleName: _S.expertList[0].exrolemodel.rolename,
                dateid: _S.dateid,
                roomid: _S.roomid,
                //英文
                entopic: _S.entopic,
                roomEnName: _S.programRoom.roomenname,
                roomEnTitle: _S.programRoom.roomentitle,
                roleEnName: _S.expertList[0].exrolemodel.roleenname,
              }
              _k.push(programList[j])
            }
          }

          _list.push(_k)
        })

        this.list = _list
        console.log(this.list)
        this.loading = false
      } catch (err) {
        console.log(err)
      }
    },
    //点击查看头像
    viewPhoto() {
      if (this.list.src) {
        ImagePreview({
          images: [this.list.src],
          startPosition: 0,
          onClose() {
            // do something
          },
          showIndex: false,
          closeOnPopstate: true,
        })
      }
    },
    goMeeting(e,dateid,roomid){
      const params = {
          m: this.$route.query.m,
          roomid: roomid,
          dateid: dateid,
		  language: this.language
      }
      this.$router.push({
          path: 'scheduleList',
          query: params,
      })
    },
    nToBr (str){
      if( str ){
        return str.replace(/\\n/g,'<br/>');
      }else{
        return str
      }
    },
  },
  
}
</script>
<style lang="scss" scoped>
.clicked {
  border-bottom: 1px solid #6366f1;
}
.details {
  .details-con {
    .details-return{
      position: fixed;
      right: 0;
      bottom: 80px;
      width: 84px;
      height: 60px;
      z-index: 100;
      background: #3b82f6;
      border-radius: 30px 0 0 30px;
      text-align: center;
      line-height: 60px;
      color: #fff;
      img{
        height: 100%;
      }
    }
    .details-con-main {
      padding: 20px;
      color: #1e293b;
      margin-bottom: 40px;
      font-size: 28px;
    }
    .details-cons{
      background: #fff;
      padding: 20px 0;
      -webkit-box-shadow: 0 2px 12px rgba(0,0,0,0.04);
      box-shadow: 0 2px 12px rgba(0,0,0,0.04);
      margin-bottom: 20px;
      border-radius: 12px;
      #guestIntroduction-con {
        margin-top: 15px;
        > h4 {
          font-size: 26px;
          border-bottom: 1px solid #e2e8f0;
          padding: 16px 20px;
          background: #3b82f6;
          border-radius: 12px 12px 0 0;
          color: #fff;
          margin-bottom: 10px;
        }
        > p{
          padding: 0 20px;
        }
      }
    }
    .details-head {
      position: relative;
      background: #fff;
      display: flex;
      padding: 0 20px;
      .guest-headimg {
        text-align: center;
        margin-right: 20px;
        width: 160px;
        height: 160px;
        border-radius: 160px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 160px;
        }
      }
      .guest-top{
        flex: 1;
      }
      .guest-intro {
        margin-top: 20px;
        font-size: 28px;
        .host,
        .guest-name {
          margin-top: 8px;
        }
      }
    }

    .details-title {
      margin: 20px 10px;
      font-size: 28px;
      color: #1e293b;
      span {
        display: inline-block;
        margin: 0px 18px;
        line-height: 60px;
        height: 60px;
      }
      & > div {
        height: 30%;
        font-size: 28px;
        .synopsis {
          .synopsis-tit {
            height: 60px;
            line-height: 60px;
            background: #e2e8f0;
            padding-left: 10px;
          }
        }
        .van-icon {
          color: #fff;
        }
      }
    }
    .details-main {
      padding-bottom: 30px;
      > div {
        background: #fff;
        margin-bottom: 24px;
        box-shadow: 0 2px 12px rgba(0,0,0,0.04);
      }
      .meeting-list{
        display: flex;
        .meeting-left{
          flex: 1
        }
        .meeting-icon{
          width: 150px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          a{
            color: #1e293b;
            display: block;
            text-align: center;
          }
          img{
            width: 90px;
          }
          img.arrow{
            width: 30%;
          }
          p{
            font-size: 12px;
            margin-top: 5px;
          }
        }
      }
      .details-main-head {
        border-bottom: 1px solid #e2e8f0;
        padding: 16px 0px;
        display: flex;
        background: #3b82f6;
        border-radius: 12px 12px 0 0;
        .details-main-head-date {
          color: #3b82f6;
          padding: 0px 0px 0px 20px;
          font-size: 28px;
          & > .van-icon {
            font-size: 40px;
            line-height: 40px;
          }
          &:after {
            border: none;
          }
          span {
            line-height: 40px;
          }
        }
        .van-cell{
          background: none;
          color: #fff;
        }
        .details-list-num {
          width: 40px;
          height: 40px;
          font-size: 28px;
          margin-right: 20px;
          border-radius: 12px;
          color: #fff;
          text-align: center;
          line-height: 40px;
        }
      }
      .details-main-con {
        position: relative;
        color: #1e293b;
        border-bottom: 1px solid #e2e8f0;
        .major-title {
          padding: 10px 0px;
          font-size: 28px;
          color: #1e293b;
          line-height: 40px;
          > i {
            width: 40px;
            font-size: 34px;
            line-height: 40px;
          }
          > div {
            color: #1e293b;
          }
          &:after {
            border: 0px;
          }
        }
      }
      #guestIntroduction-con {
        min-height: 300px;
        border-top: 1px solid #e2e8f0;
        margin-top: 20px;
        > h4 {
          font-size: 30px;
          padding-left: 20px;
          height: 60px;
          line-height: 60px;
          border-bottom: 1px solid #e2e8f0;
          padding: 16px 0px;
          display: flex;
          background: #3b82f6;
          border-radius: 12px 12px 0 0;
        }
        > p {
          width: 90%;
          margin: 0 auto;
          padding: 20px 0;
          line-height: 54px;
        }
      }
    }
  }
  ._link {
    > div {
      color: #3b82f6 !important;
    }
  }
}
</style>
